<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Liste des fiches controlées</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
    <div class="col-md-12">
  <div class="row align-items-end"> <!-- align-items-end pour aligner les éléments en bas -->
    <!-- Bouton Ajouter un control -->
    <div class="col-md-4 d-flex align-items-end" v-if="checkPermission('AddControlFiche')">
      <router-link 
        class="btn btn-primary" 
        to="/controls/ajouter-control"
      >
        <i class="fa fa-plus-circle"></i>
        Ajouter un control
      </router-link>
    </div>

    <!-- Champ Multiselect -->
    <div class="col-md-4" v-if="point_ventes.length > 1">
      <div class="form-group mb-15 mb-sm-20 mb-md-25">
        <label class="d-block text-black fw-semibold mb-10">
          Filtrer par Point de vente
        </label>
        <div style="width: 200px;">
          <Multiselect 
            
            v-model="point_vente" 
            :options="point_ventes" 
            :searchable="true" 
            track-by="label" 
            label="label" 
            placeholder="Sélectionner un point de vente" 
          />
        </div>
      </div>
    </div>

    <!-- Champ de recherche avec bouton -->
    <div class="col-md-4">
      <div class="d-flex align-items-center">
        <form class="search-bg svg-color pt-3 w-100" @submit.prevent="rechercher">
          <div class="d-flex align-items-center">
            <input
              type="text"
              v-model="searchTerm"
              @keyup="rechercher"
              class="form-control shadow-none text-black flex-grow-1"
              placeholder="Rechercher un control"
            />
            <button
              type="submit"
              class="bg-transparent text-primary transition p-0 border-0 ms-2"
            >
              <i class="flaticon-search-interface-symbol"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
               Date contrôl
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
              Fiche Produit
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
              Observation
              </th>
             
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              >ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(control, index) in controls" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_date( control.dateControl) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ control.ficheProduit.numFiche }} {{ control.ficheProduit.produit.nomProd }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ control.ObservationGlobal }}
              </td>
              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0"
              >
              <button class="btn dropdown-toggle btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">Actions</button>
                  <ul class="dropdown-menu dropdown-block" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(267px, 305px);" data-popper-placement="bottom-start">
                   <!-- <li class="dropdown-item d-flex align-items-center">
                      <router-link :to="{ name: 'EditControl', params: { id: control.id } }" 
                          class="dropdown-item d-flex align-items-center"><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>Modifier</router-link>
                    </li>
                    <li class="dropdown-item d-flex align-items-center">
                        <router-link :to="{ name: 'ViewControl', params: { id: control.id } }" class="dropdown-item d-flex align-items-center">
                            <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Détails
                        </router-link>
                    </li>-->
                    <li class="dropdown-item d-flex align-items-center" v-if="checkPermission('DeleteControlFiche')">
                      <a
                        class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="suppression(control.id,controls,'controls',`l\'control ${control.id}`)">
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1" ></i>
                         Supprimer
                      </a>
                    </li>
                  </ul>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch} from "vue";
import Swal from "sweetalert2";
import { Control } from "@/models/Control";
import ApiService from "@/services/ApiService";
import { suppression, error,format_date } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect'


export default defineComponent({
  name: "ListeControl",
  components: {
    Multiselect,
    PaginationComponent
  },
  setup(){

    let point_vente = ref<string>("");
    let point_ventes = ref([]);
    
    onMounted(async() => {

      if (JwtService.getPointDeVente()) {
              point_vente.value = await JwtService.getPointDeVenteId();
            }
            const pointVentes = await JwtService.getPointDeVentes();
            point_ventes.value = pointVentes ? pointVentes.map((point: any) => ({
              value: point.id,
              label: point.nomPointVente
            })) : [];
      
      getAllControls(point_vente.value);
    });

    const controls = ref<Array<Control>>([]);   
    const control = ref<Control>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllControls(page_, limit_);
      } catch (error) {
        //
      }
    };

    watch(point_vente, () => {
      rechercher();
    });

     function rechercher(){
      getAllControls(point_vente.value, page.value, limit.value, searchTerm.value );
    }


    const recharger = () => {
      getAllControls(point_vente.value);
    };

    // END PAGINATE

    function getAllControls(point_vent, page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/all/controlfiche?page=${page}&limit=${limi}&mot=${searchTerm}&pointvente=${point_vent}&`)
        .then(({ data }) => {
          console.log(data, )
          controls.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
      });
    }
    
    function moddifier(Editcontrols:Control) {
      control.value = Editcontrols;
    }

    const deleteControl = (id: number) => {
      ApiService.delete(`/controls/${id}`)
      .then(({ data }) => {
        Swal.fire({
          text: data.message,
          toast: true,
          icon: 'success',
          title: 'General Title',
          animation: false,
          position: 'top-right',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          heightAuto: false
        });
      })
      .catch(({ response }) => {
        Swal.fire({
          text: response.data.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Réssayer à nouveau!",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      });

      for(let i = 0; i < controls.value.length; i++) {
        if (controls.value[i].id === id) {
          controls.value.splice(i, 1);
        }
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return { controls,
      checkPermission,
     getAllControls,
     deleteControl,
     moddifier ,
     suppression,
     page, 
    totalPages,
    limit,
    totalElements,
    handlePaginate,
    rechercher,
     recharger,
    point_ventes,
    point_vente,
    format_date,
    searchTerm
  };
  },
});
</script>